//
//
//
//
//
//
//
//
//
//

import AsyncValidator from 'async-validator';
import Emitter from './mixins/emitter';

export default {
  name: 'mgFormItem',
  mixins: [Emitter],
  inject: ['form'],
  props: {
    label: {
      type: String,
      default: '',
    },
    prop: { type: String },
  },
  mounted() {
    if (this.prop) {
      this.dispatch('mgForm', 'form-add', this);
      // 设置初始值
      this.initialValue = this.fieldValue;
      this.setRules();
    }
  },
  // 组件销毁前，将实例从 Form 的缓存中移除
  beforeDestroy() {
    this.dispatch('mgForm', 'form-remove', this);
  },
  computed: {
    fieldValue() {
      return this.form.model[this.prop];
    },
  },
  data() {
    return {
      isRequired: false,
      isShowMes: false,
      message: '',
      labelFor: `input${new Date().valueOf()}`,
    };
  },
  methods: {
    setRules() {
      const rules = this.getRules();
      if (rules.length) {
        rules.forEach((rule) => {
          if (rule.required !== undefined) this.isRequired = rule.required;
        });
      }
      this.$on('form-blur', this.onFieldBlur);
      this.$on('form-change', this.onFieldChange);
    },
    getRules() {
      let formRules = this.form.rules;
      formRules = formRules ? formRules[this.prop] : [];
      return formRules;
    },
    // 过滤出符合要求的 rule 规则
    getFilteredRule(trigger) {
      const rules = this.getRules();
      return rules.filter((rule) => !rule.trigger || rule.trigger.indexOf(trigger) !== -1);
    },
    /**
     * 校验表单数据
     * @param trigger 触发校验类型
     * @param callback 回调函数
     */
    validate(trigger, cb) {
      const rules = this.getFilteredRule(trigger);
      if (!rules || rules.length === 0) return true;
      // 使用 async-validator
      const validator = new AsyncValidator({ [this.prop]: rules });
      const model = { [this.prop]: this.fieldValue };
      validator.validate(model, { firstFields: true }, (errors) => {
        this.isShowMes = !!errors;
        this.message = errors ? errors[0].message : '';
        if (cb) cb(this.message);
      });
      return false;
    },
    resetField() {
      this.message = '';
      this.form.model[this.prop] = this.initialValue;
    },
    onFieldBlur() {
      this.validate('blur');
    },
    onFieldChange() {
      this.validate('change');
    },
  },
};
